import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spin, Typography } from 'antd'; // Ant Design components
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { hosturl } from "../libs/Constants";
const { Title, Text } = Typography;

const PaymentDisplay = () => {
  const [payments, setPayments] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    if (!token) {
      setError('Please log in to view your profile.');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${hosturl}/user-details`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.data.user) {
        setError('User not found. Please log in.');
        return;
      }

      setUser(response.data.user);
      fetchPaymentData(response.data.user._id);
    } catch (err) {
      setError('An unexpected error occurred. Please login again.');
    } finally {
      setLoading(false);
    }
  };

  const fetchPaymentData = async (userId) => {
    try {
      const response = await axios.get(`${hosturl}/payments/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
            const sortedPayments = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
  
      setPayments(sortedPayments);
    } catch (err) {
      // setError('Failed to fetch payment data.');
    }
  };
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }
  if (error) {
    return <div style={errorStyles}>{error}</div>;
  }

  return (
    <div style={containerStyles}>
           <div style={{ 
        display: 'flex',
        alignItems: 'center',
        marginBottom: '24px',
        padding: '16px',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        borderRadius: '8px'
      }}>
        <Title level={3} style={{ 
          margin: 0,
          color: '#2c3e50',
          fontWeight: 600
        }}>
          Appointment Payments
        </Title>
      </div>
      <div style={paymentListStyles}>
        {payments.length === 0 ? (
          <div style={noPaymentsStyles}>No payments found.</div>
        ) : (
          payments.map((payment) => (
            <div key={payment._id} style={paymentCardStyles}>
              <div style={paymentDetailsStyles}>
                <div style={paymentInfoStyles}>
                  <div style={paymentLabelStyles}>Order ID:</div>
                  <div style={paymentValueStyles}>{payment.orderId}</div>
                </div>
                <div style={paymentInfoStyles}>
                  <div style={paymentLabelStyles}>Amount:</div>
                  <div style={paymentValueStyles}>₹{payment.amount}</div>
                </div>
                <div style={paymentInfoStyles}>
                  <div style={paymentLabelStyles}>Status:</div>
                  <div style={{ ...paymentValueStyles, color: getStatusColor(payment.status) }}>
                    {payment.status}
                  </div>
                </div>
                <div style={paymentInfoStyles}>
                  <div style={paymentLabelStyles}>Date:</div>
                  <div style={paymentValueStyles}>{new Date(payment.date).toLocaleDateString()}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

  function getStatusColor(status) {
    if (status === 'PENDING') return '#f39c12';
    if (status === 'PAID') return '#27ae60';
    return '#e74c3c'; // default color for other statuses
  }
};

// Inline style definitions
const containerStyles = {
  padding: '20px',
  maxWidth: '1200px',
  margin: '0 auto',
  // background: '#f4f7fc',
  // borderRadius: '15px',
};

const headerStyles = {
  marginBottom: '30px',
};

const titleStyles = {
  fontSize: '20 px',
  color: '#444',
  fontFamily: 'Helvetica, sans-serif',
  fontWeight: '600',
  letterSpacing: '1px',
};

const paymentListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
};

const paymentCardStyles = {
  background: '#fff',
  borderRadius: '12px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
  padding: '20px',
  transition: 'all 0.3s ease',
  marginBottom: '15px',
};

const paymentDetailsStyles = {
  display: 'flex',
  flexDirection: 'column',
};

const paymentInfoStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '12px',
};

const paymentLabelStyles = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#777',
};

const paymentValueStyles = {
  fontSize: '16px',
  fontWeight: '600',
};

const noPaymentsStyles = {
  fontSize: '18px',
  color: '#999',
  textAlign: 'center',
  padding: '50px',
};

const loadingStyles = {
  textAlign: 'center',
  fontSize: '24px',
  fontWeight: '600',
  color: '#3498db',
};

const errorStyles = {
  color: '#e74c3c',
  textAlign: 'center',
  fontSize: '18px',
  fontWeight: '600',
};

export default PaymentDisplay;
